import React from "react";

import "./InfoLinks.css";

const InfoLinks = (): JSX.Element => (
  <div className="info-links">
    <a className="info-link" href="https://www.york.gov.uk/HouseholdRecycling">
      What can be recycled
    </a>
    <a className="info-link" href="https://www.york.gov.uk/MissedWaste">
      Has a collection been missed?
    </a>
  </div>
);

export default InfoLinks;
